import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import noop from 'lodash/noop';
import TimeSelector from './TimeSelector';
import styles from './styles/IntervalSelector.less';

const IntervalSelector = ({ interval, onChange, granularity }) => {
  let disabled = false;
  const [minutely, setMinutely] = useState(false);
  const [from, to] = interval;
  let timeGranularity;

  useEffect(() => {
    // minutely flag will be set if the days is below 31 days and difference between from and to is less than 24 hours.
    if (interval[0]) {
      if (moment().diff(interval[0], 'days') > 31) {
        setMinutely(false);
      } else {
        if (moment.duration(interval[1].diff(interval[0])).asHours() < 24) {
          setMinutely(true);
        } else {
          setMinutely(false);
        }
      }
    }
  }, [interval]);

  if (typeof granularity === 'function') {
    timeGranularity = granularity(from, to);
  } else {
    timeGranularity = granularity;
  }
  if (!timeGranularity) {
    disabled = true;
  }

  const onToTimeChange = (time) => {
    const [hour, minute] = time.label.split(':');
    const end = interval[1]
      .hour(hour)
      .minute(minute)
      .startOf('minute');
    onChange([interval[0], end]);
  };

  const onFromTimeChange = (time) => {
    const [hour, minute] = time.label.split(':');
    const start = interval[0]
      .hour(hour)
      .minute(minute)
      .startOf('minute');
    onChange([start]);
  };

  return (
    <div className={styles.intervalSelector}>
      <div className={styles.title}>
        Select Time
        <span>(Optional)</span>
      </div>
      <div>
        <TimeSelector
          time={from}
          onChange={onFromTimeChange}
          disabled={disabled}
          granularity={timeGranularity}
          minutely={minutely}
          id="trends-time-picker-from"
        />
        <span className={styles.to}>to</span>
        <TimeSelector
          time={to}
          onChange={onToTimeChange}
          disabled={disabled}
          minutely={minutely}
          granularity={timeGranularity}
          id="trends-time-picker-to"
        />
      </div>
    </div>
  );
};

IntervalSelector.defaultProps = {
  onChange: noop,
  granularity: 5,
};

export default IntervalSelector;
